module.exports = __webpack_public_path__ + "img/sl3.e950cae8.png";